
export type CollectionsState = {
  collections: [];
}

export const state: CollectionsState = {
  collections: [],
};
